import { Phase } from '@/features/orders/constants/app'
import { RootState } from '@/redux/store'

export const ordersSelectors = {
    newOrderUuids: ({ orders }: RootState) => orders.uuidsByPhase[Phase.New],
    inProgressOrderUuids: ({ orders }: RootState) => orders.uuidsByPhase[Phase.InProgress],
    futureOrderUuids: ({ orders }: RootState) => orders.uuidsByPhase[Phase.Future],
    archivedOrderUuids: ({ orders }: RootState) => orders.uuidsByPhase[Phase.Archived],
    hasOpenOrders: ({ orders }: RootState) =>
        orders.uuidsByPhase[Phase.New].length > 0 ||
        orders.uuidsByPhase[Phase.InProgress].length > 0 ||
        orders.uuidsByPhase[Phase.Future].length > 0,
    orderByUuid:
        (uuid: string) =>
        ({ orders }: RootState) =>
            orders.uuidOrderMap[uuid],
    isOrdersLoaded: ({ orders }: RootState) => orders.isOrdersLoaded,
    selectedOrderUuid: ({ orders }: RootState) => orders.selectedOrderUuid,
    isOrderNonexistent:
        (uuid: string) =>
        ({ orders }: RootState) =>
            orders.isOrdersLoaded && !orders.uuidOrderMap[uuid],
    countByPhase:
        (phase: Phase) =>
        ({ orders }: RootState) =>
            orders.uuidsByPhase[phase].length,
}
